class BurgerMenu extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		this.burgerMenu = this.querySelector(".burger-menu");
		this.openButton = this.querySelector(".burger-menu__toggle--open-btn");
		this.closeButton = this.querySelectorAll(".burger-menu__toggle--close-btn");
		this.overlay = this.querySelector(".burger-menu__overlay");

		if (this.header) this.header.preventHide = false;

		this.setListeners();
	}

	open(event) {
		event.preventDefault();
		if (this.header) this.header.preventHide = true;

		this.burgerMenu.classList.add("burger-menu--open");
		this.overlay.classList.add("burger-menu__overlay--active");
		document.body.classList.add("overflow-hidden-drawer");
	}

	close(event) {
		event.preventDefault();
		this.burgerMenu.classList.remove("burger-menu--open");
		this.overlay.classList.remove("burger-menu__overlay--active");
		document.body.classList.remove("overflow-hidden-drawer");

		if (this.header) this.header.preventHide = false;

		this.burgerMenu.classList.add("hiding");

		setTimeout(() => this.burgerMenu.classList.remove("hiding"), 700);
	}

	setListeners() {
		this.openButton?.addEventListener("click", (event) => this.open(event));
		this.closeButton?.forEach((item) =>
			item.addEventListener("click", (event) => this.close(event))
		);
		this.overlay?.addEventListener("click", (event) => this.close(event));
		this.burgerMenu?.addEventListener(
			"keyup",
			(event) => event.code === "Escape" && this.close(event)
		);

		// Desktop: open the mega menu on hover, like the other (non-mega) menu items.
		this.desktopMediaQuery = window.matchMedia("(min-width: 1100px)");
		this.overButton = false;
		this.overPanel = false;

		const wrapper = this.querySelector(".burger-menu__wrapper");

		const updateHover = (event) => {
			if (!this.desktopMediaQuery.matches) return;
			clearTimeout(this.closeTimeout);
			if (this.overButton || this.overPanel) {
				this.open(event);
			} else {
				this.closeTimeout = setTimeout(() => this.close(event), 250);
			}
		};

		this.openButton?.addEventListener("mouseenter", (event) => {
			this.overButton = true;
			updateHover(event);
		});
		this.openButton?.addEventListener("mouseleave", (event) => {
			this.overButton = false;
			updateHover(event);
		});
		wrapper?.addEventListener("mouseenter", (event) => {
			this.overPanel = true;
			updateHover(event);
		});
		wrapper?.addEventListener("mouseleave", (event) => {
			this.overPanel = false;
			updateHover(event);
		});

		this.setHoverPreview(wrapper);
	}

	// Desktop: hovering a top-level item reveals its promo image below the
	// menu list (in normal flow, so the panel scrolls). Clicking the item
	// keeps the default behaviour (opens the submenu).
	setHoverPreview(wrapper) {
		const list = wrapper?.querySelector(
			".burger-menu__top > .burger-menu__list"
		);
		const previews = wrapper?.querySelector(".burger-menu__hover-previews");
		if (!list || !previews) return;

		const items = list.querySelectorAll(":scope > li");
		const previewEls = previews.querySelectorAll(
			":scope > .burger-menu__hover-preview"
		);

		const setActive = (index) => {
			previewEls.forEach((el, i) =>
				el.classList.toggle("is-active", i === index)
			);
		};

		items.forEach((li, i) => {
			li.addEventListener("mouseenter", () => {
				if (!this.desktopMediaQuery.matches) return;
				if (li.querySelector("details[open]")) {
					setActive(-1);
					return;
				}
				setActive(i);
			});
		});

		wrapper.addEventListener("mouseleave", () => setActive(-1));

		list.addEventListener("click", () => {
			setTimeout(() => {
				if (list.querySelector("details[open]")) setActive(-1);
			}, 0);
		});
	}
}

if (!customElements.get("burger-menu")) {
	customElements.define("burger-menu", BurgerMenu);
}
